export default __webpack_public_path__ + "static/media/CementLogo.f4d39659.png";